export const pageSizeOptions: Array<number> = [ 5, 10, 20, 50, 100, 200, 500, 1000, 2000 ];
export const firstPageDefault: number = 1;
